module.exports = __webpack_public_path__ + "static/img/1006_big.fe701df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1006_big.png
// module id = 23ZF
// module chunks = 1